module.exports = __webpack_public_path__ + "img/sly2.a0b08c03.jpg";